import { RuleActionAuditRecord } from '../../AIRules/types';

export const getMemberRuleActions = (
  actions: RuleActionAuditRecord[],
  memberId: string,
) => {
  return actions
    .filter(action => action.subject_id === memberId)
    .slice()
    .sort(
      (a, b) =>
        new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
    );
};
